/* Legaard - front-end behaviour. Progressive enhancement only: every section
   is fully legible with JS disabled. */
( function () {
	'use strict';

	var reduce = window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	/* ── Scroll reveal: tag the recurring layout primitives ─────────────
	   The reveal styles key off [data-reveal], but the markup is authored in
	   patterns/blocks where sprinkling presentation attributes would be
	   noise - so the recurring primitives are tagged here instead. Grids get
	   a small stagger via --reveal-delay. Content swapped in later (e.g. the
	   articles fetch) simply stays untagged and renders normally. */
	function tagReveals() {
		// Blocks that fade in as one unit.
		var singles = [
			'.legaard-section-title',
			'.legaard-split > .wp-block-column',
			'.legaard-center',
			'.legaard-contact > *',
			'.legaard-price-card',
			'.legaard-figure-wrap',
		];
		document.querySelectorAll( singles.join( ',' ) ).forEach( function ( el ) {
			el.setAttribute( 'data-reveal', '' );
		} );

		// Groups whose children cascade in with a stagger.
		var groups = [
			'.legaard-areas-grid',
			'.legaard-article-grid',
			'.legaard-trust',
			'.legaard-fcards',
			'.legaard-scards',
			'.legaard-featrows',
			'.legaard-stats',
			'.legaard-clips',
			'.legaard-cta',
		];
		document.querySelectorAll( groups.join( ',' ) ).forEach( function ( group ) {
			Array.prototype.forEach.call( group.children, function ( el, i ) {
				el.setAttribute( 'data-reveal', '' );
				el.style.setProperty( '--reveal-delay', ( ( i % 6 ) * 70 ) + 'ms' );
			} );
		} );

		// FAQ items (siblings, not wrapped in a dedicated group element).
		document.querySelectorAll( '.wp-block-details.is-style-legaard-faq' ).forEach( function ( el, i ) {
			el.setAttribute( 'data-reveal', '' );
			el.style.setProperty( '--reveal-delay', ( ( i % 4 ) * 70 ) + 'ms' );
		} );
	}

	/* ── Scroll reveal ─────────────────────────────────────────────── */
	function initReveal() {
		var nodes = document.querySelectorAll( '[data-reveal]' );
		if ( ! nodes.length || ! ( 'IntersectionObserver' in window ) ) {
			return;
		}
		document.documentElement.classList.add( 'reveal-on' );
		var io = new IntersectionObserver(
			function ( entries ) {
				entries.forEach( function ( e ) {
					if ( e.isIntersecting ) {
						e.target.classList.add( 'is-visible' );
						io.unobserve( e.target );
					}
				} );
			},
			{ rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
		);
		nodes.forEach( function ( n ) {
			io.observe( n );
		} );
	}

	/* ── Header: shrink + shadow on scroll ─────────────────────────── */
	function initHeader() {
		var header = document.querySelector( '[data-legaard-header]' );
		if ( ! header ) {
			return;
		}
		var onScroll = function () {
			header.classList.toggle( 'is-scrolled', window.scrollY > 16 );
		};
		window.addEventListener( 'scroll', onScroll, { passive: true } );
	}

	/* ── Navigation: mobile toggle + areas dropdown ────────────────── */
	function initNav() {
		var toggle = document.querySelector( '[data-nav-toggle]' );
		var panel = document.querySelector( '[data-nav-panel]' );
		var desktop = window.matchMedia( '(min-width: 992px)' );

		function setOpen( open ) {
			if ( ! toggle || ! panel ) {
				return;
			}
			if ( open ) {
				panel.setAttribute( 'data-open', '' );
			} else {
				panel.removeAttribute( 'data-open' );
			}
			toggle.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
			document.body.classList.toggle( 'legaard-nav-open', open );
		}

		if ( toggle && panel ) {
			toggle.addEventListener( 'click', function () {
				setOpen( ! panel.hasAttribute( 'data-open' ) );
			} );
			document.addEventListener( 'keydown', function ( e ) {
				if ( e.key === 'Escape' ) {
					setOpen( false );
				}
			} );
			desktop.addEventListener( 'change', function ( e ) {
				if ( e.matches ) {
					setOpen( false );
				}
			} );
		}

		var dropdown = document.querySelector( '[data-nav-dropdown]' );
		var trigger = document.querySelector( '[data-nav-trigger]' );
		if ( dropdown && trigger ) {
			trigger.addEventListener( 'click', function ( e ) {
				e.stopPropagation();
				// Desktop opens on hover (CSS); keep click for the mobile panel.
				if ( desktop.matches ) {
					return;
				}
				var open = dropdown.classList.toggle( 'is-open' );
				trigger.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
			} );
			document.addEventListener( 'click', function ( e ) {
				if ( ! dropdown.contains( e.target ) ) {
					dropdown.classList.remove( 'is-open' );
					trigger.setAttribute( 'aria-expanded', 'false' );
				}
			} );
			document.addEventListener( 'keydown', function ( e ) {
				if ( e.key === 'Escape' ) {
					dropdown.classList.remove( 'is-open' );
					trigger.setAttribute( 'aria-expanded', 'false' );
				}
			} );
		}
	}

	/* ── Testimonials carousel ─────────────────────────────────────── */
	function initTestimonials() {
		document.querySelectorAll( '[data-legaard-testimonials]' ).forEach( function ( root ) {
			if ( ! ( 'IntersectionObserver' in window ) ) {
				bindTestimonials( root );
				return;
			}
			var io = new IntersectionObserver(
				function ( entries ) {
					if ( entries[ 0 ] && entries[ 0 ].isIntersecting ) {
						io.disconnect();
						bindTestimonials( root );
					}
				},
				{ rootMargin: '240px 0px' }
			);
			io.observe( root );
		} );
	}

	function bindTestimonials( root ) {
			var scroller = root.querySelector( '.legaard-testi__scroller' );
			var dotsWrap = root.querySelector( '[data-testi-dots]' );
			var prev = root.querySelector( '[data-testi-prev]' );
			var next = root.querySelector( '[data-testi-next]' );
			var cards = scroller ? scroller.querySelectorAll( '.legaard-testi-card' ) : [];
			if ( ! scroller || ! cards.length ) {
				return;
			}

			function step() {
				var card = cards[ 0 ];
				var style = getComputedStyle( scroller );
				var gap = parseFloat( style.columnGap || style.gap ) || 32;
				return card.offsetWidth + gap;
			}
			function maxScroll() {
				return Math.max( 0, scroller.scrollWidth - scroller.clientWidth );
			}
			function maxIndex() {
				var s = step();
				if ( ! s ) {
					return 0;
				}
				return Math.max( 0, Math.round( maxScroll() / s ) );
			}
			function pages() {
				return maxIndex() + 1;
			}
			function active() {
				var s = step();
				if ( ! s ) {
					return 0;
				}
				return Math.min( maxIndex(), Math.max( 0, Math.round( scroller.scrollLeft / s ) ) );
			}
			function goTo( idx ) {
				var last = maxIndex();
				var i = Math.max( 0, Math.min( last, idx ) );
				var left = i >= last ? maxScroll() : i * step();
				scroller.scrollTo( { left: left, behavior: 'smooth' } );
			}

			// Build dots.
			var dots = [];
			function buildDots() {
				if ( ! dotsWrap ) {
					return;
				}
				dotsWrap.innerHTML = '';
				dots = [];
				var n = pages();
				for ( var i = 0; i < n; i++ ) {
					( function ( idx ) {
						var b = document.createElement( 'button' );
						b.className = 'legaard-testi__dot';
						b.setAttribute( 'aria-label', 'Strana ' + ( idx + 1 ) );
						b.innerHTML = '<span></span>';
						b.addEventListener( 'click', function () {
							goTo( idx );
						} );
						dotsWrap.appendChild( b );
						dots.push( b );
					} )( i );
				}
			}
			function sync() {
				var a = active();
				dots.forEach( function ( d, i ) {
					d.setAttribute( 'aria-current', i === a ? 'true' : 'false' );
				} );
				if ( prev ) {
					prev.disabled = a <= 0;
				}
				if ( next ) {
					next.disabled = a >= dots.length - 1;
				}
			}

			buildDots();
			sync();
			scroller.addEventListener( 'scroll', function () {
				window.requestAnimationFrame( sync );
			} );
			window.addEventListener( 'resize', function () {
				buildDots();
				sync();
			} );
			if ( prev ) {
				prev.addEventListener( 'click', function () {
					goTo( active() - 1 );
				} );
			}
			if ( next ) {
				next.addEventListener( 'click', function () {
					goTo( active() + 1 );
				} );
			}

			root.querySelectorAll( '.legaard-testi-card' ).forEach( function ( card ) {
				var body = card.querySelector( '.legaard-testi__quote-body' );
				var more = card.querySelector( '[data-testi-more]' );
				if ( ! body || ! more ) {
					return;
				}
				if ( body.scrollHeight <= body.clientHeight + 1 ) {
					return;
				}
				more.hidden = false;
				more.addEventListener( 'click', function () {
					var open = card.classList.toggle( 'is-expanded' );
					more.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
					more.textContent = open ? 'Zobraziť menej' : 'Zobraziť viac';
				} );
			} );
	}

	/* ── Services marquee ──────────────────────────────────────────── */
	function initMarquee() {
		if ( reduce ) {
			return;
		}
		var stacked = window.matchMedia( '(max-width: 991px)' );
		document.querySelectorAll( '[data-legaard-marquee]' ).forEach( function ( root ) {
			var rows = root.querySelectorAll( '.legaard-marquee__row' );
			var state = [];
			rows.forEach( function ( row ) {
				state.push( { el: row, pos: 0, half: row.scrollWidth / 2, dir: parseFloat( row.getAttribute( 'data-dir' ) ) || -1 } );
			} );
			var speed = 0.3;
			function wrap( v, half ) {
				if ( ! half ) {
					return v;
				}
				while ( v <= -half ) {
					v += half;
				}
				while ( v > 0 ) {
					v -= half;
				}
				return v;
			}
			function loop() {
				if ( stacked.matches ) {
					state.forEach( function ( s ) {
						s.el.style.transform = '';
					} );
					window.requestAnimationFrame( loop );
					return;
				}
				state.forEach( function ( s ) {
					s.pos = wrap( s.pos + s.dir * speed, s.half );
					s.el.style.transform = 'translate3d(' + s.pos + 'px,0,0)';
				} );
				window.requestAnimationFrame( loop );
			}
			window.addEventListener( 'resize', function () {
				state.forEach( function ( s ) {
					s.half = s.el.scrollWidth / 2;
				} );
			} );
			window.requestAnimationFrame( loop );
		} );
	}

	/* ── Cube word rotator ─────────────────────────────────────────── */
	function initCube() {
		document.querySelectorAll( '[data-legaard-cube]' ).forEach( function ( el ) {
			var words = ( el.getAttribute( 'data-words' ) || '' ).split( '|' ).filter( Boolean );
			if ( words.length < 2 ) {
				return;
			}
			var i = 0;
			var longest = words.reduce( function ( a, b ) {
				return b.length > a.length ? b : a;
			}, '' );
			el.innerHTML =
				'<span class="legaard-cube__strut" aria-hidden="true">' + longest + '</span>' +
				'<span class="legaard-cube__box">' +
				'<span class="legaard-cube__face legaard-cube__front">' + words[ 0 ] + '</span>' +
				'<span class="legaard-cube__face legaard-cube__bottom">' + words[ 1 ] + '</span>' +
				'</span>';
			var box = el.querySelector( '.legaard-cube__box' );
			var front = el.querySelector( '.legaard-cube__front' );
			var bottom = el.querySelector( '.legaard-cube__bottom' );

			if ( reduce ) {
				setInterval( function () {
					i = ( i + 1 ) % words.length;
					front.textContent = words[ i ];
				}, 2000 );
				return;
			}
			box.addEventListener( 'transitionend', function () {
				box.classList.remove( 'is-flip' );
				i = ( i + 1 ) % words.length;
				front.textContent = words[ i ];
				bottom.textContent = words[ ( i + 1 ) % words.length ];
				void box.offsetWidth; // reflow so removing is-flip doesn't animate back
			} );
			setInterval( function () {
				box.classList.add( 'is-flip' );
			}, 1600 );
		} );
	}

	/* ── FAQ accordion: one open at a time, animated open/close ─────── */
	function initFaq() {
		var items = Array.prototype.slice.call(
			document.querySelectorAll( '.wp-block-details.is-style-legaard-faq' )
		);

		items.forEach( function ( d ) {
			var summary = d.querySelector( 'summary' );
			if ( ! summary ) {
				return;
			}

			// Wrap the answer as panel(overflow hidden) > inner(padding). The
			// panel height is tweened; the inner holds the padding so nothing
			// jumps when the height is released back to auto.
			var panel = document.createElement( 'div' );
			panel.className = 'legaard-faq__panel';
			var inner = document.createElement( 'div' );
			inner.className = 'legaard-faq__inner';
			var node = summary.nextSibling;
			while ( node ) {
				var nextNode = node.nextSibling;
				inner.appendChild( node );
				node = nextNode;
			}
			panel.appendChild( inner );
			d.appendChild( panel );
			// Tells the CSS to key the icon rotation off .is-open (in sync with
			// the tween) instead of the [open] attribute, which lags on close.
			d.classList.add( 'is-enhanced' );
			d.__panel = panel;
			d.__inner = inner;
			if ( d.open ) {
				d.classList.add( 'is-open' );
				panel.style.height = 'auto';
			}

			panel.addEventListener( 'transitionend', function ( e ) {
				if ( e.propertyName !== 'height' ) {
					return;
				}
				if ( d.classList.contains( 'is-open' ) ) {
					// Release to auto so the panel stays fluid on reflow.
					panel.style.height = 'auto';
				} else {
					d.open = false;
				}
			} );

			summary.addEventListener( 'click', function ( e ) {
				e.preventDefault();
				if ( d.classList.contains( 'is-open' ) ) {
					collapse( d );
				} else {
					items.forEach( function ( other ) {
						if ( other !== d && other.classList.contains( 'is-open' ) ) {
							collapse( other );
						}
					} );
					expand( d );
				}
			} );
		} );

		function expand( d ) {
			var panel = d.__panel;
			d.open = true;
			d.classList.add( 'is-open' );
			window.clearTimeout( d.__timer );
			if ( reduce ) {
				panel.style.height = 'auto';
				return;
			}
			// Target the inner's exact (sub-pixel) height so releasing to
			// auto afterwards lands on the same value - no end snap.
			panel.style.height = d.__inner.getBoundingClientRect().height + 'px';
			// Fallback in case transitionend does not fire.
			d.__timer = window.setTimeout( function () {
				if ( d.classList.contains( 'is-open' ) ) {
					panel.style.height = 'auto';
				}
			}, 360 );
		}

		function collapse( d ) {
			var panel = d.__panel;
			d.classList.remove( 'is-open' );
			window.clearTimeout( d.__timer );
			if ( reduce ) {
				panel.style.height = '0px';
				d.open = false;
				return;
			}
			// Give the transition an explicit starting height (auto -> px),
			// force a reflow, then collapse to 0.
			panel.style.height = d.__inner.getBoundingClientRect().height + 'px';
			void panel.offsetHeight;
			panel.style.height = '0px';
			d.__timer = window.setTimeout( function () {
				if ( ! d.classList.contains( 'is-open' ) ) {
					d.open = false;
				}
			}, 360 );
		}
	}

	/* ── Articles: filter + paginate without a full page load ──────────
	   Progressive enhancement: the chips and pager are real links, so with
	   JS off (or on error) the browser just navigates normally. With JS we
	   fetch the target page, swap the #legaard-articles fragment in place and
	   update the URL, so filtering and pagination feel instant. */
	function initArticles() {
		var root = document.getElementById( 'legaard-articles' );
		if ( ! root || ! window.fetch || ! ( window.history && window.history.pushState ) ) {
			return;
		}
		var loading = false;

		function sameOrigin( href ) {
			var a = document.createElement( 'a' );
			a.href = href;
			return a.origin === window.location.origin;
		}

		function interceptable( e ) {
			if ( e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey ) {
				return null;
			}
			var a = e.target.closest( 'a' );
			if ( ! a || ! root.contains( a ) ) {
				return null;
			}
			if ( ! a.closest( '.legaard-chips' ) && ! a.closest( '.legaard-pager' ) ) {
				return null;
			}
			if ( ! a.href || ! sameOrigin( a.href ) ) {
				return null;
			}
			return a;
		}

		function swap( html ) {
			var doc = new DOMParser().parseFromString( html, 'text/html' );
			var next = doc.getElementById( 'legaard-articles' );
			if ( ! next ) {
				return false;
			}
			root.innerHTML = next.innerHTML;
			if ( doc.title ) {
				document.title = doc.title;
			}
			return true;
		}

		function scrollToTop() {
			var header = document.querySelector( '[data-legaard-header]' );
			var offset = ( header ? header.offsetHeight : 0 ) + 24;
			var y = root.getBoundingClientRect().top + window.scrollY - offset;
			window.scrollTo( { top: y < 0 ? 0 : y, behavior: reduce ? 'auto' : 'smooth' } );
		}

		function load( url, push ) {
			if ( loading ) {
				return;
			}
			loading = true;
			root.classList.add( 'is-loading' );
			window.fetch( url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'fetch' } } )
				.then( function ( r ) {
					return r.text();
				} )
				.then( function ( html ) {
					if ( swap( html ) ) {
						if ( push ) {
							window.history.pushState( { legaardArticles: true }, '', url );
						}
						scrollToTop();
					} else {
						window.location.href = url;
					}
				} )
				.catch( function () {
					window.location.href = url;
				} )
				.then( function () {
					loading = false;
					root.classList.remove( 'is-loading' );
				} );
		}

		root.addEventListener( 'click', function ( e ) {
			var a = interceptable( e );
			if ( ! a ) {
				return;
			}
			e.preventDefault();
			load( a.href, true );
		} );

		window.addEventListener( 'popstate', function () {
			if ( document.getElementById( 'legaard-articles' ) ) {
				load( window.location.href, false );
			}
		} );
	}

	/* ── Cookie consent: banner + preferences panel ─────────────────────
	   No server round-trip: consent is a first-party cookie the browser
	   sets/reads directly. Scripts registered server-side via
	   legaard_consent_enqueue_script() but awaiting consent arrive here as
	   window.legaardConsentPending and get injected the moment their
	   category is granted - no page reload needed. */
	function initConsent() {
		var root = document.querySelector( '[data-legaard-consent]' );
		if ( ! root ) {
			return;
		}

		var cookieName = root.getAttribute( 'data-consent-cookie' ) || 'legaard_consent';
		var version = parseInt( root.getAttribute( 'data-consent-version' ), 10 ) || 1;
		var banner = root.querySelector( '[data-consent-banner]' );
		var panel = root.querySelector( '[data-consent-panel]' );
		var categoryInputs = Array.prototype.slice.call( root.querySelectorAll( '[data-consent-category]' ) );

		function readCookie() {
			var match = document.cookie.match( new RegExp( '(?:^|; )' + cookieName + '=([^;]*)' ) );
			if ( ! match ) {
				return null;
			}
			try {
				var parsed = JSON.parse( decodeURIComponent( match[ 1 ] ) );
				if ( parsed && parsed.v === version && parsed.categories ) {
					return parsed;
				}
			} catch ( e ) {
				// Ignore a malformed/legacy cookie - treated as "no consent yet".
			}
			return null;
		}

		function writeCookie( categories ) {
			var value = JSON.stringify( { v: version, categories: categories, ts: Date.now() } );
			var secure = window.location.protocol === 'https:' ? '; Secure' : '';
			document.cookie = cookieName + '=' + encodeURIComponent( value ) + '; Max-Age=15552000; Path=/; SameSite=Lax' + secure;
		}

		function activatePending( categories ) {
			if ( ! window.legaardConsentPending ) {
				return;
			}
			window.legaardConsentPending.forEach( function ( item ) {
				if ( item.__loaded || ! categories[ item.category ] ) {
					return;
				}
				item.__loaded = true;
				if ( item.inline ) {
					var inline = document.createElement( 'script' );
					inline.text = item.inline;
					document.body.appendChild( inline );
				}
				var s = document.createElement( 'script' );
				s.src = item.src;
				s.async = true;
				s.id = 'legaard-consent-' + item.handle;
				document.body.appendChild( s );
			} );
		}

		function currentCategories() {
			var consent = readCookie();
			var categories = {};
			categoryInputs.forEach( function ( input ) {
				var key = input.getAttribute( 'data-consent-category' );
				categories[ key ] = input.disabled ? true : !! ( consent && consent.categories[ key ] );
			} );
			return categories;
		}

		function fillPanel( categories ) {
			categoryInputs.forEach( function ( input ) {
				if ( input.disabled ) {
					return;
				}
				input.checked = !! categories[ input.getAttribute( 'data-consent-category' ) ];
			} );
		}

		function hideBanner() {
			banner.hidden = true;
		}

		function openPanel() {
			fillPanel( currentCategories() );
			panel.hidden = false;
		}

		function closePanel() {
			panel.hidden = true;
		}

		function apply( categories ) {
			writeCookie( categories );
			hideBanner();
			closePanel();
			activatePending( categories );
		}

		function allCategories( value ) {
			var categories = {};
			categoryInputs.forEach( function ( input ) {
				categories[ input.getAttribute( 'data-consent-category' ) ] = input.disabled ? true : value;
			} );
			return categories;
		}

		// Initial state: show the banner only if there's no valid consent yet;
		// either way, activate whatever the visitor already agreed to.
		var existing = readCookie();
		if ( existing ) {
			activatePending( existing.categories );
			root.hidden = false;
			banner.hidden = true;
		} else {
			root.hidden = false;
			banner.hidden = false;
		}

		root.querySelectorAll( '[data-consent-accept]' ).forEach( function ( btn ) {
			btn.addEventListener( 'click', function () {
				apply( allCategories( true ) );
			} );
		} );
		root.querySelectorAll( '[data-consent-reject]' ).forEach( function ( btn ) {
			btn.addEventListener( 'click', function () {
				apply( allCategories( false ) );
			} );
		} );
		root.querySelectorAll( '[data-consent-open]' ).forEach( function ( btn ) {
			btn.addEventListener( 'click', openPanel );
		} );
		root.querySelectorAll( '[data-consent-close]' ).forEach( function ( btn ) {
			btn.addEventListener( 'click', closePanel );
		} );
		var saveBtn = root.querySelector( '[data-consent-save]' );
		if ( saveBtn ) {
			saveBtn.addEventListener( 'click', function () {
				var categories = {};
				categoryInputs.forEach( function ( input ) {
					categories[ input.getAttribute( 'data-consent-category' ) ] = input.disabled ? true : input.checked;
				} );
				apply( categories );
			} );
		}

		// The footer's "Nastavenia cookies" link reopens the panel any time,
		// pre-filled with whatever's currently in effect.
		document.querySelectorAll( '[data-cookie-settings]' ).forEach( function ( link ) {
			link.addEventListener( 'click', function ( e ) {
				e.preventDefault();
				openPanel();
			} );
		} );
	}

	/* ── Forms: validate in place, then POST via fetch ──────────────────
	   Without this, `required` on a checkbox still posts (contact used to
	   carry novalidate) and the server redirects back to the top of the page.
	   Native HTML5 stays as the no-JS fallback. */
	function fieldErrorTarget( field ) {
		return field.closest( 'label' ) || field.parentNode;
	}

	function setFieldError( field, message ) {
		var wrap = fieldErrorTarget( field );
		var errId = ( field.form && field.form.classList.contains( 'legaard-news' ) ? 'news' : 'kontakt' ) + '-' + field.name + '-chyba';
		var err = field.form ? field.form.querySelector( '#' + errId ) : null;
		field.classList.toggle( 'is-invalid', !! message );
		wrap.classList.toggle( 'is-invalid', !! message );
		if ( ! message ) {
			if ( err ) {
				err.remove();
			}
			field.removeAttribute( 'aria-invalid' );
			field.removeAttribute( 'aria-describedby' );
			return;
		}
		if ( ! err ) {
			err = document.createElement( 'span' );
			err.className = 'legaard-field-error';
			err.id = errId;
			if ( field.type === 'checkbox' && wrap.tagName === 'LABEL' ) {
				wrap.insertAdjacentElement( 'afterend', err );
			} else if ( wrap.tagName === 'LABEL' ) {
				wrap.appendChild( err );
			} else {
				var row = field.closest( '.legaard-news__row' );
				if ( row ) {
					row.insertAdjacentElement( 'afterend', err );
				} else {
					field.insertAdjacentElement( 'afterend', err );
				}
			}
		}
		err.textContent = message;
		field.setAttribute( 'aria-invalid', 'true' );
		field.setAttribute( 'aria-describedby', errId );
	}

	function setFormError( form, message ) {
		var box = form.querySelector( '[data-form-error]' );
		if ( ! box ) {
			return;
		}
		if ( message ) {
			box.hidden = false;
			box.textContent = message;
		} else {
			box.hidden = true;
		}
	}

	function validateField( field ) {
		if ( ! field || field.disabled || field.type === 'hidden' || field.name === 'legaard_website' ) {
			return '';
		}
		if ( field.type === 'checkbox' ) {
			if ( field.required && ! field.checked ) {
				return field.form && field.form.classList.contains( 'legaard-news' )
					? 'Pred odberom označte súhlas so spracovaním údajov.'
					: 'Pred odoslaním označte súhlas so spracovaním údajov.';
			}
			return '';
		}
		var value = ( field.value || '' ).trim();
		if ( field.required && ! value ) {
			if ( field.name === 'meno' ) {
				return 'Zadajte meno a priezvisko.';
			}
			if ( field.name === 'email' ) {
				return 'Zadajte e-mail.';
			}
			if ( field.name === 'sprava' ) {
				return 'Napíšte stručný opis veci.';
			}
			return 'Toto pole je povinné.';
		}
		if ( value && field.type === 'email' && ! field.checkValidity() ) {
			return 'Zadajte platný e-mail.';
		}
		return '';
	}

	function validateForm( form ) {
		var first = null;
		Array.prototype.forEach.call( form.elements, function ( field ) {
			if ( ! field.name || field.type === 'submit' || field.type === 'hidden' ) {
				return;
			}
			var message = validateField( field );
			setFieldError( field, message );
			if ( message && ! first ) {
				first = field;
			}
		} );
		return first;
	}

	function applyServerErrors( form, fields ) {
		var first = null;
		Array.prototype.forEach.call( form.elements, function ( field ) {
			if ( ! field.name || field.type === 'submit' || field.type === 'hidden' ) {
				return;
			}
			var message = fields && fields[ field.name ] ? fields[ field.name ] : '';
			setFieldError( field, message );
			if ( message && ! first ) {
				first = field;
			}
		} );
		return first;
	}

	function ajaxUrl( form ) {
		return form.getAttribute( 'data-ajax' ) || form.action.replace( 'admin-post.php', 'admin-ajax.php' );
	}

	var recaptchaLoader = null;

	function loadRecaptcha( key ) {
		if ( window.grecaptcha && window.grecaptcha.execute ) {
			return Promise.resolve();
		}
		if ( recaptchaLoader ) {
			return recaptchaLoader;
		}
		recaptchaLoader = new Promise( function ( resolve, reject ) {
			var s = document.createElement( 'script' );
			s.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent( key );
			s.async = true;
			s.onload = function () {
				if ( window.grecaptcha && window.grecaptcha.ready ) {
					window.grecaptcha.ready( resolve );
				} else {
					reject( new Error( 'recaptcha' ) );
				}
			};
			s.onerror = function () {
				recaptchaLoader = null;
				reject( new Error( 'recaptcha' ) );
			};
			document.head.appendChild( s );
		} );
		return recaptchaLoader;
	}

	function recaptchaToken( form ) {
		var key = form.getAttribute( 'data-recaptcha' );
		if ( ! key ) {
			return Promise.resolve( '' );
		}
		var action = form.classList.contains( 'legaard-news' ) ? 'newsletter' : 'contact';
		return loadRecaptcha( key ).then( function () {
			return window.grecaptcha.execute( key, { action: action } );
		} );
	}

	function bindAjaxForm( form ) {
		if ( ! window.fetch ) {
			return;
		}
		form.noValidate = true;
		var attempted = false;
		var btn = form.querySelector( '[type="submit"]' );

		function recheck( e ) {
			if ( ! attempted || ! e.target || ! e.target.name ) {
				return;
			}
			setFieldError( e.target, validateField( e.target ) );
		}

		if ( form.getAttribute( 'data-recaptcha' ) ) {
			form.addEventListener( 'focusin', function () {
				loadRecaptcha( form.getAttribute( 'data-recaptcha' ) );
			}, { once: true } );
		}

		form.addEventListener( 'input', recheck );
		form.addEventListener( 'change', recheck );

		form.addEventListener( 'submit', function ( e ) {
			e.preventDefault();
			attempted = true;
			setFormError( form, '' );
			var first = validateForm( form );
			if ( first ) {
				first.focus();
				if ( first.scrollIntoView ) {
					first.scrollIntoView( { block: 'center', behavior: reduce ? 'auto' : 'smooth' } );
				}
				return;
			}
			if ( btn ) {
				btn.disabled = true;
				btn.setAttribute( 'aria-busy', 'true' );
			}
			recaptchaToken( form )
				.then( function ( token ) {
					var body = new FormData( form );
					if ( token ) {
						body.set( 'g-recaptcha-response', token );
					}
					return window.fetch( ajaxUrl( form ), {
						method: 'POST',
						body: body,
						credentials: 'same-origin',
						headers: { 'X-Requested-With': 'XMLHttpRequest' },
					} );
				} )
				.then( function ( res ) {
					return res.json().then( function ( data ) {
						return data;
					}, function () {
						throw new Error( 'bad-json' );
					} );
				} )
				.then( function ( data ) {
					if ( data && data.success && data.data && data.data.html ) {
						var wrap = document.createElement( 'div' );
						wrap.innerHTML = data.data.html;
						var next = wrap.firstElementChild;
						if ( ! next ) {
							throw new Error( 'empty' );
						}
						if ( form.classList.contains( 'legaard-news' ) ) {
							track( 'sign_up', { method: 'newsletter' } );
						} else {
							track( 'generate_lead', { lead_source: 'kontaktny_formular' } );
						}
						form.replaceWith( next );
						if ( next.scrollIntoView ) {
							next.scrollIntoView( { block: 'nearest', behavior: reduce ? 'auto' : 'smooth' } );
						}
						return;
					}
					var payload = ( data && data.data ) || {};
					var invalid = applyServerErrors( form, payload.fields || {} );
					if ( invalid ) {
						setFormError( form, '' );
						invalid.focus();
					} else {
						setFormError( form, payload.message || 'Správu sa nepodarilo odoslať. Skúste to znova.' );
					}
				} )
				.catch( function () {
					setFormError( form, form.getAttribute( 'data-recaptcha' )
						? 'Odoslanie sa nepodarilo overiť. Skúste to znova.'
						: 'Spojenie zlyhalo. Skúste to znova.' );
				} )
				.then( function () {
					if ( btn && form.parentNode ) {
						btn.disabled = false;
						btn.removeAttribute( 'aria-busy' );
					}
				} );
		} );
	}

	function initForms() {
		document.querySelectorAll( 'form.legaard-contact-card, form.legaard-news' ).forEach( bindAjaxForm );
	}

	/* ── Lead tracking for GA4 ───────────────────────────────────────────
	   window.gtag only exists after the visitor grants analytics consent
	   (inc/analytics.php), so track() is a silent no-op until then. The
	   event names match the key events configured in the GA4 property:
	   generate_lead (contact form sent), phone_click, email_click. */
	function track( name, params ) {
		if ( typeof window.gtag !== 'function' ) {
			return;
		}
		try {
			window.gtag( 'event', name, params || {} );
		} catch ( e ) {
			// Analytics must never break the page.
		}
	}

	function initLeadTracking() {
		document.addEventListener( 'click', function ( e ) {
			var target = e.target;
			if ( ! target || ! target.closest ) {
				return;
			}
			var link = target.closest( 'a[href^="tel:"], a[href^="mailto:"]' );
			if ( ! link ) {
				return;
			}
			var href = link.getAttribute( 'href' ) || '';
			track( href.indexOf( 'tel:' ) === 0 ? 'phone_click' : 'email_click', {
				link_url: href,
				link_text: ( link.textContent || '' ).replace( /\s+/g, ' ' ).trim().slice( 0, 100 ),
			} );
		}, true );
	}

	/* ── Instagram: "Zobraziť viac" reveals the pre-rendered second row ──
	   First click expands the grid in place; the link then turns into
	   "Všetky reels na Instagrame" and behaves like a normal link. */
	function initInstagram() {
		document.querySelectorAll( '[data-ig-more]' ).forEach( function ( more ) {
			var clips = more.parentNode.querySelector( '.legaard-clips' );
			if ( ! clips ) {
				return;
			}
			more.addEventListener( 'click', function ( e ) {
				if ( clips.classList.contains( 'is-expanded' ) ) {
					return;
				}
				e.preventDefault();
				clips.classList.add( 'is-expanded' );
				clips.querySelectorAll( '.legaard-clip.is-extra' ).forEach( function ( el, i ) {
					el.style.setProperty( '--reveal-delay', ( i * 70 ) + 'ms' );
					el.classList.add( 'is-visible' );
				} );
				var label = more.querySelector( 'span' );
				if ( label ) {
					label.textContent = more.getAttribute( 'data-ig-more-all' ) || label.textContent;
				}
			} );
		} );
	}

	function ready( fn ) {
		if ( document.readyState !== 'loading' ) {
			fn();
		} else {
			document.addEventListener( 'DOMContentLoaded', fn );
		}
	}

	ready( function () {
		initHeader();
		initNav();
		initConsent();
		initForms();
		initLeadTracking();
		var rest = function () {
			tagReveals();
			initReveal();
			initTestimonials();
			initMarquee();
			initCube();
			initFaq();
			initArticles();
			initInstagram();
		};
		if ( 'requestIdleCallback' in window ) {
			window.requestIdleCallback( rest, { timeout: 400 } );
		} else {
			window.setTimeout( rest, 1 );
		}
	} );
} )();
